export * from './select-tree';
import { rejectNotString, ensureString } from "../../utility/fp"
import { DEFAULT_NODE_HEIGHT } from './select-tree';
import { sum, flatten, transpose, propOr, view, lensPath, set, tail } from 'ramda';
import { arraysEqual } from '../../utility';

export const createNode = ({
  text = '',
  value = '',
  selected = false,
  expanded = false,
  children = [],
  path = 0
}) => {
  value = rejectNotString(value);
  text = ensureString(text, value);
  // children = children && children.map(createNode);

  return {
    text,
    value,
    selected,
    expanded,
    children,
    path
  }
}

export const getNodeHeight = (node = createNode()) => {
  // console.log(node);
  return DEFAULT_NODE_HEIGHT + (
    (node.children && node.children.length > 0 && node.expanded)
      ? sum(node.children.map(getNodeHeight))
      : 0
  );
}

export const flat = (array) => {
  var result = [];
  array.forEach(function (a) {
    result.push(a);
    if (Array.isArray(a.children)) {
      result = result.concat(flat(a.children));
    }
  });
  return result;
}
export const childranizePath = (path) => {
  if (path.length > 1) {
    const children = Array(path.length - 1).fill('children');
    return flatten(transpose([path, children]));
  } else {
    return path;
  }
}

export const getNodeExpanded = propOr(false, 'expanded');

/** Access the Node object from the Tree Object */
export const getNode = (element) => {
  const elPath = childranizePath(element.path);
  return view(lensPath(elPath));
}

/** Returns the Setter of the Node object from the Tree Object */
export const setNode = (element) => {
  const elPath = childranizePath(element.path);
  return set(lensPath(elPath));
}

/** Set the Name value of the node and all the children */
export const setNodeChildren = (element = createNode(), name, value) => {
  element[name] = value;
  element.children = element.children.map(e => setNodeChildren(e, name, value));
  return element;
}

/** Set the Name value of the node and all the children */
export const setNodeNdChildren = (element = createNode(), name, value) => {
  const children = element.children.map(e => setNodeChildren(e, name, value));
  return {
    ...element,
    [name]: value,
    children,
  };
}


export const preserveExpanded = (nodes = [createNode()], previousNodes = [createNode()]) => {
  return nodes.map(node => {
    return {
      ...node,
      expanded: getNodeExpanded(getNode(node)(previousNodes)),
      children: preserveExpanded(node.children, previousNodes)
    };
  })
}


export const climbNodePath = (node = createNode({}), path, pathIndex, selectFunc = getSelected, nodeSetter = defaultNodeSetter) => {
  const currentIndex = path[pathIndex];
  // if (!currentIndex) {
  //   return node;
  // }
  const children = node?.children?.map((e, index) => {
    if (currentIndex == index) {
      return climbNodePath(e, path, pathIndex + 1, selectFunc, nodeSetter);
    } else {
      return e;
    }
  });
  const targetNode = nodeSetter(node);

  const selected = selectFunc(targetNode || node, targetNode?.children || children);


  return {
    ...node,
    children,
    selected,
    ...targetNode || {},
  }
}

export const defaultNodeSetter = node => null;

export const createTargetNodeSetter = (path, name, value) => (node = createNode({})) => {
  if (arraysEqual(node.path, path)) {
    return setNodeNdChildren(node, name, value);
  } else {
    return null;
  }
};



export const getAllChildrenSelected = (node, children) =>
  children.every(e => e.selected == true) ? true : false;
const getSelected = (node, children) => node.selected;


export const checkNodeArrayPath = (nodeArray, el, { selectFunc = getAllChildrenSelected, nodeSetter = defaultNodeSetter } = {}) => {
  const path = el.path;
  if (path.length == 1) {
    return nodeArray.map((e, index) => {
      if (index == path[0]) {
        return nodeSetter(e);
      } else {
        return e;
      }
    })
  } else {
    return nodeArray.map((e, index) => {
      if (index == path[0]) {
        return climbNodePath(e, path, 1, selectFunc, nodeSetter);
      } else {
        return e;
      }
    })
  }
}

// const findNode = (nodeArray, nodePath) => {
//   return nodeArray.map((e, index) => {
//     if (index ==  nodePath[0]) {
//       return findNode(e, tail(nodePath));
//     } else {
//       return false;
//     }
//   })
// }
